// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__snmWh","id":"styles_id__-IN1l"};